// extracted by mini-css-extract-plugin
export default {"logoText":"Chrome_logoText__+dj-U","animation-clip":"Chrome_animation-clip__ARc7p","animation-clip-access-denied":"Chrome_animation-clip-access-denied__ogZGl"};